import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { FREIGHTS, AUCTION } from "helpers/routes";
import InfoFreightHeader from "./InfoFreightHeader";
import CompanyRoute from "components/common/InfoPopup/CompanyRoute";
import FreightFiltersData from "components/FreightComponents/FreightsTable/FreightsFilters";
import CompanyData from "components/common/InfoPopup/CompanyData";
import CompanyDocuments from "components/common/InfoPopup/CompanyDocuments";
import Contacts from "components/common/InfoPopup/Contacts";
import EmployeesSection from "components/common/InfoPopup/EmployeesSection";
// TODO move it in another place
// import PopupReview from "components/PublicTableElements/PopupReview";
import Navigation from "components/common/InfoPopup/Navigation";
import CompanyReviews from "components/common/InfoPopup/CompanyReviews";
import styles from "./styles.module.scss";

const COMPANY_POPUP_MENU = {
    ABOUT: "about",
    DOCUMENTS: "documents",
    ROUTE: "route",
    REVIEW: "review",
    DETAILS: "details",
    CONTACTS: "contacts",
    EMPLOYEES: "employees",
};

export default function ExchangeFreightInfo({ data, mode, showChatButton, handleOpenChat, mobileButtons, searchCoordinates }) {
    const [companyTypeInfo, setPopupMode] = useState(COMPANY_POPUP_MENU.DETAILS);
    const { t } = useTranslation();
    const profileData = useSelector((state) => state.profile.profileData);

    const isOwner = data && profileData && profileData.id === data.user_id;

    const componentToRender = {
        [COMPANY_POPUP_MENU.DETAILS]: <FreightFiltersData filtersData={data} isOwner={isOwner} />,
        [COMPANY_POPUP_MENU.ABOUT]: <CompanyData companyData={data} />,
        [COMPANY_POPUP_MENU.DOCUMENTS]: (
            <CompanyDocuments
                documentsData={data.preview_documents}
                companyRole={data.company_role}
                showExpectedDocuments={!isOwner}
                onRequestDocument={!isOwner && showChatButton ? handleOpenChat : undefined}
            />
        ),
        [COMPANY_POPUP_MENU.ROUTE]: (
            <CompanyRoute
                data={data}
                loadingFrom={[
                    { lat: data.loading_address.location.latitude, ln: data.loading_address.location.longitude },
                    ...data.additional_loading_addresses.map((item) => ({ lat: item.location.latitude, ln: item.location.longitude})),
                ]}
                loadingTo={[
                    { lat: data.unloading_address.location.latitude, ln: data.unloading_address.location.longitude },
                    ...data.additional_unloading_addresses.map((item) => ({ lat: item.location.latitude, ln: item.location.longitude})),
                ]}
                searchCoordinates={searchCoordinates}
            />
        ),
        [COMPANY_POPUP_MENU.CONTACTS]: (
            <Contacts
                contactId={data.id}
                apiRoute={mode === "auction" ? AUCTION.getContacts : FREIGHTS.getContacts}
            />
        ),
        [COMPANY_POPUP_MENU.EMPLOYEES]: (
            <EmployeesSection
                companyId={data.company_id}
            />
        ),
        [COMPANY_POPUP_MENU.REVIEW]: <CompanyReviews companyId={data.company_id} />,
    };

    const handleMenuItemClick = (id) => () => {
        setPopupMode(id);
    };

    const navigationItems = [
        {
            id: COMPANY_POPUP_MENU.DETAILS,
            active: COMPANY_POPUP_MENU.DETAILS === companyTypeInfo,
            content: t("exchangeModal.learn_more_section.heading"),
        },
        {
            id: COMPANY_POPUP_MENU.ROUTE,
            active: COMPANY_POPUP_MENU.ROUTE === companyTypeInfo,
            content: t("exchangeModal.itinerary_section.heading"),
        },
        {
            id: COMPANY_POPUP_MENU.CONTACTS,
            active: COMPANY_POPUP_MENU.CONTACTS === companyTypeInfo,
            content: t("exchangeModal.contact_section.heading"),
        },
        {
            id: COMPANY_POPUP_MENU.ABOUT,
            active: COMPANY_POPUP_MENU.ABOUT === companyTypeInfo,
            content: t("exchangeModal.main_info_section.heading"),
        },
        {
            id: COMPANY_POPUP_MENU.EMPLOYEES,
            active: COMPANY_POPUP_MENU.EMPLOYEES === companyTypeInfo,
            content: t("exchangeModal.employees_section.heading"),
        },
    ];
    if (data && ((!isOwner) || (data.preview_documents && data.preview_documents.length > 0))) {
        navigationItems.push({
            id: COMPANY_POPUP_MENU.DOCUMENTS,
            active: COMPANY_POPUP_MENU.DOCUMENTS === companyTypeInfo,
            content: t("exchangeModal.document_section.heading"),
        });
    }
    navigationItems.push({
        id: COMPANY_POPUP_MENU.REVIEW,
        active: COMPANY_POPUP_MENU.REVIEW === companyTypeInfo,
        content: t("exchangeModal.review_section.heading"),
    });

    return (
        <>
            <InfoFreightHeader data={data} showChatButton={showChatButton} onChatClick={handleOpenChat} />
            {mobileButtons && <div className={styles.mobileButtons}>{mobileButtons}</div>}
            <Navigation onClick={handleMenuItemClick} items={navigationItems} />
            {componentToRender[companyTypeInfo]}
        </>
    );
}
